export const CONNECTION_TYPES = [
    { key: 'connected', label: 'common.connected' },
    { key: 'disconnected', label: 'common.notconnected' },
    { key: 'private', label: 'common.private' },
];